export default __webpack_public_path__ + "static/media/Deltagerliste_eksempel.7bcc3f13.csv";